export default {"src":"/_next/static/media/withDrawCash.da4b0c91.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};